<template>
    <div class="alert" :class="classes" role="alert">
        <div class="alert__icon">
            <img :src="'/images/icons/' + type + '.svg'">
        </div>
        <slot></slot>
    </div>
</template>

<script>
export default {
    props: {
        "type" : {
            type: String,
            validator: (val) => ['success', 'warning', 'error', 'info'].includes(val),
            default: 'success'
        }
    },
    computed: {
        classes() {
            return [
                "alert--"+this.type
            ]
        }
    }
}
</script>
